import { CustomValidatorArgs } from '../types/CSVTypes';

const durationValidator = ({ value }: CustomValidatorArgs) => {
  if (value == null || (typeof value === 'string' && value.trim() === '')) {
    return null;
  }

  const duration = Number(value);

  if (isNaN(duration)) {
    return 'notNumber';
  }

  if (duration < 0) {
    return 'isNegative';
  }

  return null;
};

export default durationValidator;
